import { SubNavigationItem } from 'types/navigation'

export const EVENT_NAVIGATION_ITEMS: SubNavigationItem[] = [
  { label: 'Upcoming', path: '/events/upcoming' },
  { label: 'Workshops', path: '/events/workshops' },
  { label: 'Group Meetings', path: '/events/group-meetings' },
  { label: 'Office Hours', path: '/events/office-hours' },
  { label: 'Past Events', path: '/events/past' },
  { label: 'My Events', path: '/events/my-events' },
]

export const EDUCATION_NAVIGATION_ITEMS: SubNavigationItem[] = [
  { label: 'Featured', path: '/education' },
  { label: 'Tracks', path: '/education/tracks' },
  { label: 'Articles', path: '/education/articles' },
  { label: 'Interviews', path: '/education/interviews' },
  { label: 'Playbooks', path: '/education/playbooks' },
  { label: 'Podcast', path: '/education/podcast' },
  { label: 'Videos', path: '/education/videos' },
]

export const ABOUT_NAVIGATION_ITEMS: SubNavigationItem[] = [
  { label: 'Overview', path: '/about' },
  { label: 'Mission', path: '/about/mission' },
  { label: 'Culture', path: '/about/culture' },
  { label: 'Sitemap', path: '/sitemaps' },
]

export const SIGNUP_PATHS = {
  register: '/accelerator/register',
  profile: '/accelerator/profile',
  plans: '/accelerator/plans',
  signupRequest: '/accelerator/start',
  payment: '/accelerator/payment',
  /** External funnel bridge: commit SignupRequest → GroupRequest manage tab */
  commitSignupRequest: '/requests/signup/commit',
  /** WWFM / Capital Compass post-Lovable continue funnel */
  whoWillFundMeContinue: '/continue/who-will-fund-me',

  investorOutreachRegister: '/investor-outreach/register',
  investorOutreachPitchDeck: '/investor-outreach/pitch-deck',
  investorOutreachPayment: '/investor-outreach/payment',
  investorOutreachSubmitted: '/investor-outreach/submitted',

  investorMatchingRegister: '/investors/matching/register',
  investorMatchingPitchDeck: '/investors/matching/pitch-deck',
  investorMatchingPayment: '/investors/matching/payment',
  investorMatchingSubmitted: '/investors/matching/submitted',
}
